import { createFileRoute } from "@tanstack/react-router";
import { ProductDetailPage } from "@/features/food-ingredients/product-detail-page";
import type { InvProductId } from "@brewbase/db/types";

export const Route = createFileRoute("/food-app/ingredients/$product_id")({
  component: function ProductDetailRoute() {
    const { product_id } = Route.useParams();
    return <ProductDetailPage productId={product_id as InvProductId} />;
  },
  parseParams: (params) => ({
    product_id: parseInt(params.product_id, 10),
  }),
});
